import React from 'react';
import PropTypes from 'prop-types';
import { observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { Rate } from '@elevio/elevio-styles/dist/components/hq';

const ObservableRate = ({ fieldId, allowHalf, response, ...rest }) => (
  <Rate
    key={`Rate_${fieldId}`}
    id={fieldId}
    allowHalf={allowHalf}
    {...rest}
    value={response || 0}
  />
);

ObservableRate.propTypes = {
  fieldId: PropTypes.number.isRequired,
  allowHalf: PropTypes.bool,
  response: PropTypes.oneOfType([
    mobxPropTypes.observableArray, // eslint-disable-line react/no-typos
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
    PropTypes.shape({
      file: PropTypes.shape({
        name: PropTypes.string,
      }),
      fileList: mobxPropTypes.observableArray, // eslint-disable-line react/no-typos
    }),
  ]),
};

ObservableRate.defaultProps = {
  allowHalf: false,
  response: 0,
};

export default observer(ObservableRate);



// WEBPACK FOOTER //
// ./src/components/rate/index.js